import React from 'react';
import Tooltip from '@atlaskit/tooltip';
import { User } from '../../modules/auth/types';
import Avatar from '../avatar';
import moment from 'moment';

const BookingInfoCell = React.memo(function UserCell({
  user,
  updated,
}: {
  user?: User;
  updated?: Date;
}) {
  return (
    <Tooltip content={(
      <span>
        {user?.name || 'AdministratieBot'}
        <br />
        {' '}
        {moment(updated).format('DD-MM-YYYY HH:mm:ss')}
      </span>
    )}
    >
      <Avatar name={user?.name || '**'}  />
    </Tooltip>
  );
});

export default BookingInfoCell;
